export class UpdateKeyValueRequest {
    
    public id : number=0;
    public descripcion : string="";
}